import { useAuth0 } from "@auth0/auth0-react";
import { getJwtPayload } from "../../utilities/getJwtPayload";
import { Button } from "@mui/material";

export default function LogInWithAllScopes() {
    const { loginWithRedirect, getAccessTokenSilently } = useAuth0();

    const loginWithAllScopes = async () => {
        const token = await getAccessTokenSilently();
        const payload = getJwtPayload(token);
        const scope = payload.permissions?.join(" ");
        await loginWithRedirect({
            authorizationParams: {
                scope,
            },
        });
        return;
    };

    return (
        <Button variant="contained" onClick={loginWithAllScopes}>
            Log in with all scopes
        </Button>
    );
}
